export default __webpack_public_path__ + "static/media/cancel-icon.114862d7.svg";